import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/map';
import { Env } from '../env';
import { Observable } from 'rxjs/Observable';
import { Permission } from '../models/permission';
import { ContractListItemSource } from '../models/contractListItemSource';
import { ContractSource } from '../models/contractSource';
import { observableToBeFn } from 'rxjs/testing/TestScheduler';

@Injectable()
export class ContractsService {

    constructor(private http: HttpClient, private global: Env) { }

    getAll( page:number = 0 , ownerDni:string = "" , ownerRuc:string = "" , status:string = "" , tenantDni:string = "" , size:number = 10):Observable<ContractListItemSource[]>{
      let filtro = "";

      if ( ownerDni > "" ){
        filtro += "&ownerDni="+ownerDni;
      }
      if ( ownerRuc > "" ) {
        filtro += "&ownerRuc="+ownerRuc;
      }
      if ( status > "" ){
        filtro += "&status="+status;
      }
      if ( tenantDni > "" ) {
        filtro += "&tenantDni="+tenantDni;
      }

      const url = this.global.contract+'?page='+page+filtro+'&size='+size
      console.log(url);
      return this.http.get(url).map((res: ContractListItemSource[]) => {
        return res;
      });
    }

    get(id):Observable<ContractSource[]> {
      const url = this.global.contract+'/'+id;

      return this.http.get(url).map((res: ContractSource[]) => {
        return res;
      });
    }

    delete(id:number = null){
      const url = this.global.contract+'/'+id;

      return this.http.delete(url);
    }
}



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/services/contracts.service.ts